"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voteUtil = (voteValue, likeDislike) => {
    let likes = 0;
    let dislikes = 0;
    if (likeDislike === 1) {
        if (voteValue === 1) {
            voteValue = 0;
            likes--;
        }
        else if (voteValue === 0) {
            voteValue = 1;
            likes++;
        }
        else {
            voteValue = 1;
            dislikes--;
            likes++;
        }
    }
    else {
        if (voteValue === 1) {
            voteValue = -1;
            likes--;
            dislikes++;
        }
        else if (voteValue === 0) {
            voteValue = -1;
            dislikes++;
        }
        else {
            voteValue = 0;
            dislikes--;
        }
    }
    return { voteValue, likes, dislikes };
};
//# sourceMappingURL=VoteUtil.js.map


//////////////////
// WEBPACK FOOTER
// ../common/dist/VoteUtil.js
// module id = 614
// module chunks = 0